export default __webpack_public_path__ + "android-ios-app.webp";